export default __webpack_public_path__ + "static/media/check-mark.fc03b3e4.svg";